/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    Button,
    Row,
    Col,
    CardBody,
    CardFooter,
    FormGroup,
    Label,
    Input,
    Container,
    CardHeader,
} from "reactstrap";

import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import SweetAlert from "react-bootstrap-sweetalert";
import ItemGambar1 from "components/SelectedFile/ItemGambar1";
import CurrencyInput from 'react-currency-input-field';

export default function UpdateItemGambarPettyCash(props) {
    const token = localStorage.token;
    const codepettycash = localStorage.cp;
    const history = useHistory();
    const [description, setDescription] = useState("");
    const [image1, setImage1] = useState("");
    const [alert, setAlert] = React.useState(null);
    const [loading, setLoading] = useState(false)
    const [id, setId] = useState("")
    const [nominal, setNominal] = useState(0)

    useEffect(() => {
        getById();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };
        axios
            .get(
                `${process.env.REACT_APP_API_BASE_URL}/petty-cash/get-by-code/${codepettycash}`,
                { headers }
            )
            .then((data) => {
                setId(data.data.response.id)
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const UploadGambar = () => {
        setLoading(true)
        hideAlert();
        const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
        };

        const myjson = JSON.stringify({
            keterangan: description,
            nominal: nominal
        });

        let data = new FormData();
        data.append("body", myjson)
        data.append("bukti", image1)
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/save-item/${codepettycash}`, data, { headers })
            .then(function (response) {
                setSuccessAlert(response.data.message);
                setLoading(false)
                setTimeout(() => history.push(`/mobile/pettycash/item/${id}`), 1000);
            })
            .catch(function (error) {
                setGagalAlert(error.response.data.message);
                setLoading(false)
            });
    }

    const setSuccessAlert = (id) => {
        setAlert(
            <SweetAlert
                success
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        )
    }

    const setGagalAlert = (id) => {
        setAlert(
            <SweetAlert
                danger
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        );
    };

    const setQuestionAlert = () => {
        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Lanjutkan"
                confirmBtnBsStyle="danger"
                title="Apakah Kamu Yakin?"
                onConfirm={UploadGambar}
                onCancel={hideAlert}
                focusCancelBtn
            />
        );
    };

    const hideAlert = () => {
        setAlert(null);
    }

    const Nominal = (e) => {
        const value = e === undefined ? 'undefined' : e;
        setNominal(value || ' ');
    };


    return (
        <div>
            {alert}
            <div>
                <SimpleHeaderMobile to={`/mobile/pettycash/item/${id}`} judul="Tambah Dokumen" />
                <Container className="mt--6" fluid>
                    <Row>
                        <div className="col">
                            <Card className="bg-secondary shadow">
                                <CardHeader>
                                    <h3>Tambah Dokumen</h3>
                                </CardHeader>
                                <CardBody>
                                    <Row md="12">
                                        <Col md="6">
                                            <FormGroup row>
                                                <Label
                                                    className="form-control-label"
                                                    for="exampleEmail"
                                                    sm={4}
                                                >
                                                    Nominal
                                                    <span className="text-danger">*</span>
                                                </Label>
                                                <Col sm={7}>
                                                    <CurrencyInput
                                                        id="validation-example-2-field"
                                                        placeholder="Rp0"
                                                        // allowDecimals={false}
                                                        value={nominal}
                                                        onValueChange={Nominal}
                                                        className={`form-control`}
                                                        prefix={'Rp'}
                                                        step={10}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                    className="form-control-label"
                                                    for="exampleEmail"
                                                    sm={4}
                                                >
                                                    Keterangan
                                                    <span className="text-danger">*</span>
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="textarea"
                                                        name="descripsi"
                                                        rows="8"
                                                        placeholder="Masukan Keterangan"
                                                        value={description}
                                                        onChange={(e) => {
                                                            setDescription(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            {/* <Card className="bg-secondary shadow">
                                <CardHeader>
                                    <h3>Upload Gambar</h3>
                                </CardHeader>
                                <CardBody>
                                    <Row md="12">
                                        <Col md="10">
                                            <FormGroup row>
                                                <Label
                                                    className="form-control-label" for="exampleEmail" sm={3}>
                                                    <b>Foto Produk</b><br></br>
                                                    Format gambar .jpg .jpeg .png dan ukuran minimum <b>300px X 300px</b>.
                                                </Label>
                                                <Col sm={2}>
                                                    <label
                                                        className="form-control-label" htmlFor1="formId1" >
                                                        <input
                                                            hidden
                                                            id="formId1"
                                                            name="file"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => {
                                                                setImage1(event.target.files[0]);
                                                            }}
                                                        />
                                                        <ItemGambar1
                                                            onclick={() => { }}
                                                            imageSrc1={image1 != "" && image1 != undefined ? URL.createObjectURL(image1) : null}
                                                        />
                                                    </label>
                                                </Col>
                                                <Col sm={2}>
                                                    <label
                                                        className="form-control-label" htmlFor1="formId1" >
                                                        <input
                                                            hidden
                                                            id="formId1"
                                                            name="file"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => {
                                                                setImage2(event.target.files[0]);
                                                            }}
                                                        />
                                                        <ItemGambar2
                                                            onclick={() => { }}
                                                            imageSrc2={image2 != "" && image2 != undefined ? URL.createObjectURL(image2) : null}
                                                        />
                                                    </label>
                                                </Col>
                                                <Col sm={2}>
                                                    <label
                                                        className="form-control-label" htmlFor1="formId1" >
                                                        <input
                                                            hidden
                                                            id="formId1"
                                                            name="file"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => {
                                                                setImage3(event.target.files[0]);
                                                            }}
                                                        />
                                                        <ItemGambar3
                                                            onclick={() => { }}
                                                            imageSrc3={image3 != "" && image3 != undefined ? URL.createObjectURL(image3) : null}
                                                        />
                                                    </label>
                                                </Col>
                                                <Col sm={2}>
                                                    <label
                                                        className="form-control-label" htmlFor1="formId1" >
                                                        <input
                                                            hidden
                                                            id="formId1"
                                                            name="file"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => {
                                                                setImage4(event.target.files[0]);
                                                            }}
                                                        />
                                                        <ItemGambar4
                                                            onclick={() => { }}
                                                            imageSrc4={image4 != "" && image4 != undefined ? URL.createObjectURL(image4) : null}
                                                        />
                                                    </label>
                                                </Col>
                                                <Col sm={2}>
                                                    <label
                                                        className="form-control-label" htmlFor1="formId1" >
                                                        <input
                                                            hidden
                                                            id="formId1"
                                                            name="file"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => {
                                                                setImage5(event.target.files[0]);
                                                            }}
                                                        />
                                                        <ItemGambar5
                                                            onclick={() => { }}
                                                            imageSrc4={image5 != "" && image5 != undefined ? URL.createObjectURL(image5) : null}
                                                        />
                                                    </label>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <CardFooter>
                                    <Link className="btn btn-info" to="/admin/item">
                                        Kembali
                                    </Link>
                                    <Button color="danger" onClick={() => setQuestionAlert()}>
                                        Simpan
                                    </Button>
                                </CardFooter>
                            </Card> */}
                            <Card className="bg-secondary shadow">
                                <CardHeader>
                                    <h3>Upload Dokumen</h3>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md="12">
                                            <FormGroup>
                                                {/* <Label className="form-control-label" for="exampleEmail">
                                                    <b>Foto Produk</b><br />
                                                    Format gambar .jpg .jpeg .png dan ukuran minimum <b>300px X 300px</b>.
                                                </Label> */}

                                                <Row className="mt-3">
                                                    {[1].map((num, index) => (
                                                        <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                                            <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                                                <input
                                                                    hidden
                                                                    id={`formId${num}`}
                                                                    name="file"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(event) => {
                                                                        const file = event.target.files[0];
                                                                        if (file) {
                                                                            switch (num) {
                                                                                case 1: setImage1(file); break;
                                                                                default: break;
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                {num === 1 && (
                                                                    <ItemGambar1
                                                                        onclick={() => { }}
                                                                        imageSrc1={image1 ? URL.createObjectURL(image1) : null}
                                                                    />
                                                                )}
                                                            </label>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>

                                <CardFooter disabled={loading} className="d-flex justify-content-between">
                                    <Link className="btn btn-info" to={`/mobile/pettycash/item/${id}`}>
                                        Kembali
                                    </Link>
                                    <Button disabled={loading} color="danger" onClick={() => setQuestionAlert()}>
                                        Simpan
                                    </Button>
                                </CardFooter>
                            </Card>
                        </div>
                    </Row>
                </Container>
            </div>
        </div>

    );
};